import React from 'react';

// Custom hook for dark mode
function useDarkMode() {
  // Check if there's a saved mode in localStorage, use it if available
  const savedMode = localStorage.getItem('isDarkMode');
  const [isDarkMode, setIsDarkMode] = React.useState(savedMode === 'true'); // Convert from string to boolean

  React.useEffect(() => {
    const htmlElement = document.documentElement;

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasDarkClass = htmlElement.classList.contains('dark');
          setIsDarkMode(hasDarkClass);
          // Save the mode to localStorage when it changes
          localStorage.setItem('isDarkMode', hasDarkClass.toString()); // Convert to string
        }
      }
    });

    observer.observe(htmlElement, { attributes: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return isDarkMode;
}

export default useDarkMode;
